export const initialStatePoliza = {
   id_poliza: null,
   id_certificado: null,
   id_usuario: null,
   id_cliente: null,
   id_seccion: null,
   id_producto: null,
   id_compania: null,
   id_art_poliza: null,
   fecha_desde: null,
   fecha_hasta: null,
   suma_asegurada_total: null,
   premio: null,
   id_forma_pago: null,
   domicilio: null,
   id_localidad: null,
   id_provincia: null,
   masa_salarial: null,
   capitas: null,
   posibilidad_cierre: null,
   id_moneda: null,
   localidad: null,
   isMapaLoaded: false,
   motivoNoGanado: null,
   codigo_postal: null,
};

export const initialStateLote = {
   id_poliza: null,
   nombre: null,
   hectareas: null,
   cotizacion: null,
   cultivo: {
      id_campania: null,
      id_cultivo: null,
      label: null,
      valor_referencial: null,
   },
   moneda: null,
   id_localidad: null,
   id_provincia: null,
   id_departamento: null,
   helada: false,
   viento: false,
   planchado: false,
   incendio_rastrojo: false,
   coordsDibujo: null,
};

export function getInitialStatePoliza() {
   return {
      poliza: { ...initialStatePoliza },
      polizas: [],
      casosAsignados: {},
      lote: { ...initialStateLote },
      lotes: [],
      retomado: false,
      nextLoteId: 1,
      prospectosAsignados: [],
      seguimientos: [],
      comentarios: [],
      estados: [],
      secciones: [],
      polizasList: {
         items: [],
         offset: 0,
         limit: 50,
         loading: false,
         finished: false,
         filters: {
            cliente: '',
            usuario: '',
            empresa: '',
            ramo: null,
            numero: '',
            fecha_desde: null,
            fecha_hasta: null,
         },
      },
      solicitudesList: {
         items: [],
         offset: 0,
         limit: 50,
         loading: false,
         finished: false,
         filters: {
            cliente: '',
            usuario: '',
            empresa: '',
            ramo: null,
            numero: '',
            estado: null,
            fecha_creacion_desde: null,
            fecha_creacion_hasta: null,
         },
      },
   };
}

export default getInitialStatePoliza();
